import axios from '../../../axios';
import IArrangementLevel from '../types/IArrangementLevel';

const url = 'invoicingservice/api/arrangement-level';

interface IArrangementLevelFilter {
  clientFilter?: { value: string }[];
  visibility?: string;
}

export const createNewFeeArrangementLevel = (clientId: string, name: string) =>
  axios.post(`${url}?clientId=${clientId}`, name);

export const getArrangementLevelPage = (page: number, filterFormData: IArrangementLevelFilter) =>
  getArrangementLevelByPageAndSize(page, 20, filterFormData);

export const getArrangementLevelByPageAndSize = (
  page: number,
  size: number,
  filterFormData: IArrangementLevelFilter
) => {
  const params = new URLSearchParams({
    page: page.toString(),
    size: size.toString(),
  });
  if (filterFormData?.clientFilter) {
    filterFormData.clientFilter.forEach((client) => {
      params.append('clientIds[]', client.value);
    });
  }
  if (filterFormData?.visibility !== undefined) {
    params.append('visibility', filterFormData.visibility === 'Visible' ? 'true' : 'false');
  }
  return axios.get(`${url}?${params.toString()}`);
};

export const replaceFeeArrangementLevel = (arrangementLevelEntity: IArrangementLevel) =>
  axios.put(`${url}`, arrangementLevelEntity);

export const getAllFeeArrangementLevelsForClient = (clientId: string) =>
  axios.get(url + '/all?clientId=' + clientId);
